<script setup>
// @ts-check
/**
 * @import { Ref } from 'vue'
 */
import { ref } from 'vue'
import { setup } from './useLogoutFooter'
import { route } from '@/utils/ziggy.js'

const props = defineProps({
  linkListApiUrl: {
    type: String,
    required: false,
    default: '',
  },
})

/** @type {Ref<HTMLElement | null>} */
const refLogoutFooter = ref(null)

const {
  linksByGroup,
  isPc,
  globalUserServiceActive,
  globalCompanyServiceActive,

  globalUserOpenToggle,
  globalCompanyOpenToggle,
} = setup(props.linkListApiUrl)

defineExpose({
  refLogoutFooter,
})
</script>
<template>
  <!-- footer -->
  <footer
    ref="refLogoutFooter"
    class="md_footer md_footer--logout"
  >
    <div class="footerWrap">
      <div class="copyArea">
        <div class="logoCell">
          <a :href="route('student.top')">
            <img
              src="/student_site/imageFile/logo.svg"
              alt=""
            />
          </a>
        </div>
        <div class="copyCell">
          <p class="copy">
            新卒学生向け就活・就職、学生スカウト専用サイトiroots。<br />
            上場企業からベンチャー企業まで400社以上が利用中。自己分析ツール[性格・価値観分析]で自分の才能や可能性を解析出来ます。
          </p>
        </div>
      </div>
      <div class="linkArea">
        <ul class="linkList">
          <li class="link">
            <a
              :href="route('lp.thoughts.index')"
              target="_blank"
              >irootsの想い</a
            >
          </li>
          <li class="link">
            <a
              href="https://iroots.jp/plus/"
              target="_blank"
              >アイルーツ プラス（学生向けメディア）</a
            >
          </li>
          <li class="link">
            <a
              :href="route('student.about.use.index')"
              target="_blank"
              >利用規約</a
            >
          </li>
          <li class="link">
            <a
              :href="route('student.about.privacy-policy.index')"
              target="_blank"
              >プライバシーポリシー</a
            >
          </li>
          <li class="link">
            <a
              :href="route('student.about.recruitment-policy.index')"
              target="_blank"
              >求人情報の的確な表示に関するポリシー</a
            >
          </li>
          <li class="link">
            <a
              href="https://corp.en-japan.com/"
              target="_blank"
              >運営会社について</a
            >
          </li>
          <li class="link">
            <a
              href="https://iroots.jp/html/pr/company/index.html"
              target="_blank"
              >採用担当者はこちら</a
            >
          </li>
        </ul>
      </div>
      <div
        v-cloak
        class="otherSiteLink"
      >
        <div
          v-if="
            isPc &&
            ((linksByGroup['JobSeeker'] != undefined && linksByGroup['JobSeeker'].length != 0) ||
              (linksByGroup['Company'] != undefined && linksByGroup['Company'].length != 0))
          "
          class="enSiteVertical"
        >
          <div class="title">【エングループ】サービス一覧</div>
          <div
            v-if="linksByGroup['JobSeeker'] != undefined && linksByGroup['JobSeeker'].length != 0"
            class="list clearfix"
            @click="globalUserOpenToggle"
          >
            <div class="toggle">
              <span :class="{ open: globalUserServiceActive }">求職者様向け求人サービス</span>
            </div>
            <div
              v-show="globalUserServiceActive"
              class="listList"
              style="display: block"
            >
              <ul>
                <li
                  v-for="(link, i) in linksByGroup['JobSeeker']"
                  :key="`${link.site_url}_${link.site_sub}`"
                  :class="{ last: i + 1 == linksByGroup['JobSeeker'].length }"
                >
                  <div class="siteLinkArea">
                    <div class="rightArea">
                      <span class="site"
                        ><a
                          :href="link.site_url"
                          target="_blank"
                          v-html="link.site"
                        ></a
                      ></span>
                      <span
                        class="siteSub"
                        v-html="link.site_sub"
                      ></span>
                    </div>
                    <div class="leftArea">
                      <img
                        :src="link.site_image"
                        :alt="link.site_alt"
                      />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            v-if="linksByGroup['Company'] != undefined && linksByGroup['Company'].length != 0"
            class="list clearfix"
            @click="globalCompanyOpenToggle"
          >
            <div class="toggle">
              <span :class="{ open: globalCompanyServiceActive }">企業様向けサービス</span>
            </div>
            <div
              v-show="globalCompanyServiceActive"
              class="listList listListCompany"
              style="display: block"
            >
              <ul>
                <li
                  v-for="(link, i) in linksByGroup['Company']"
                  :key="`${link.site_url}_${link.site_sub}`"
                  :class="{ last: i + 1 == linksByGroup['Company'].length }"
                >
                  <div class="siteLinkArea">
                    <div class="rightArea">
                      <span class="site"
                        ><a
                          :href="link.site_url"
                          target="_blank"
                          v-html="link.site"
                        ></a
                      ></span>
                      <span
                        class="siteSub"
                        v-html="link.site_sub"
                      ></span>
                    </div>
                    <div class="leftArea">
                      <img
                        :src="link.site_image"
                        :alt="link.site_alt"
                      />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="copyrightArea">
        <small class="copyright">&copy; en Inc.</small>
      </div>
    </div>
  </footer>
  <!-- /footer -->
</template>
